import React from "react";

export default function CoachFeedback(props: any) {
    return (
        <div className="coach-feedback-parent">
            <img style={{ height: '150px' }} src="assets/img/coach-svgrepo-com.svg"></img>
            {props.content}
        </div>
    );
}
